import React from 'react';

import SecurityFooter from 'componentsV2/DS/SecurityFooter';
import { Header } from 'screens/DS/Success/components/Header';

import { OFFER_UNAVAILABLE_TEXTS } from '../../constants/texts';
import {
  OFFER_CLOSED_REASON,
  OFFER_NOT_STARTED_REASON,
  OFFER_REFUSED_REASON,
  OFFER_SOLD_OUT_REASON,
  OFFER_SOLD_OUT_REFUSED_REASON,
  type OfferUnavailableReason,
} from '../../utils/offerUnavailableRoute';

const TEXTS_BY_REASON: Partial<
  Record<
    OfferUnavailableReason,
    (typeof OFFER_UNAVAILABLE_TEXTS)[keyof typeof OFFER_UNAVAILABLE_TEXTS]
  >
> = {
  [OFFER_NOT_STARTED_REASON]: OFFER_UNAVAILABLE_TEXTS.notStarted,
  [OFFER_CLOSED_REASON]: OFFER_UNAVAILABLE_TEXTS.closed,
  [OFFER_REFUSED_REASON]: OFFER_UNAVAILABLE_TEXTS.paymentClosed,
  // FIN-8119 (D08): esgotado tem texto próprio, não o de prazo.
  [OFFER_SOLD_OUT_REASON]: OFFER_UNAVAILABLE_TEXTS.soldOut,
  [OFFER_SOLD_OUT_REFUSED_REASON]: OFFER_UNAVAILABLE_TEXTS.paymentSoldOut,
};

/**
 * FIN-8016: página genérica (sem marca fixa) de oferta indisponível, para o
 * lead desviado e o pagamento recusado. Sem link de volta ao pagamento.
 * FIN-8011: layout do design, com o Header do /success (cores da marca pelo
 * provider do DS no AppRoot). Logo e "Atendimento" vêm do AppRoot. Recusa
 * PLAN_SALES_NOT_STARTED e motivo ausente ou desconhecido usam a genérica.
 */
export function OfferUnavailableScreen({
  reason,
}: {
  reason?: OfferUnavailableReason;
}) {
  const texts =
    (reason && TEXTS_BY_REASON[reason]) || OFFER_UNAVAILABLE_TEXTS.generic;

  return (
    <main
      className="flex min-h-[calc(100vh-200px)] flex-col items-center pb-10 pt-6 text-center"
      data-testid="offer-unavailable-screen"
    >
      {/* Mesmo cabeçalho do /success: ícone e título em secondary-pure (cor
          da marca do produto) e subtítulo na cor padrão do DS. */}
      <div className="flex w-full max-w-[400px] flex-col items-center gap-2">
        <Header icon="alarm" title={texts.title} subtitle={texts.message} />
      </div>

      <div className="mt-auto w-full pt-16">
        <SecurityFooter
          showShieldText={false}
          recaptchaEnterprise
          dataCy="offer-unavailable"
        />
      </div>
    </main>
  );
}
